<template>
    <div class="modal fade custom-modal" id="opbkRuleModal" :class="{ in: isShowModal, active: isShow}" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="common-modal-close" @click="onModalClose">
                    <img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>
                <div class="modal-body">
                    <div class="modal-title">
                        {{ruleTitle}}
                    </div>

                    <div class="modal-text" v-html="rule">
                        
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OpenBookingRulePopup",
    props: {
        isShow: {
            type: Boolean
        },
        rule: {
            type: String
        },
        ruleTitle: {
            type: String
        }
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>


<style lang="less" scoped>
.modal-body {
    padding: 20px;
}
.modal-dialog {
    top: 5%;
    width: 900px;
}

.modal {
    .common-modal-close {
        position: absolute;
        width: 28px;
        top: 10px;
        right: 10px;
        z-index: 2;
        cursor: pointer;
    }
    .modal-title {
        font-size: 22px;
        font-weight: bold;
        text-align: center;
    }
    .modal-text {
        margin-top: 20px;
        padding: 0 10px;
        line-height: 25px;
    }
}

.modal.active {
    display: block;
    overflow-x: hidden;
    overflow-y: scroll;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
